'use client';

import { useTranslations } from 'next-intl';
import React, { useState } from 'react';

import { BgDpcCodeCategoryType } from '@/data/dtos/Resouces/BgDentalProcedureCodes/BgDpcCodeCategoryType';

interface DentalCodesCatalogFiltrationProps {
	className?:string;
	codeCategories: BgDpcCodeCategoryType[];
	onCategoryChange?: (category: string) => void; // Add this prop
}

export default function DentalCodesCatalogFiltration({ codeCategories, onCategoryChange, className = 'form-select' }: DentalCodesCatalogFiltrationProps) {
	const [selectedCategory, setSelectedCategory] = useState('all');
	const t = useTranslations('page.r-bg-dental-procedure-codes-catalog');

	const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const value = e.target.value;
		setSelectedCategory(value);
		onCategoryChange && onCategoryChange(value); // Notify parent if callback provided
	};

	return (
		<select className={className} aria-label="all" value={selectedCategory} onChange={handleChange}>
			<option value="all">{t('dental-codes-section.select_all_categories')}</option>
			{codeCategories.map((codeCategory) => (
				<option value={codeCategory.code} key={codeCategory.code}>
					{codeCategory.title}
				</option>
			))}
		</select>
	);
}
